import Swal from "sweetalert2";
import { FaCalendarAlt, FaTimes } from "react-icons/fa";

import {
  Users,
  UserPlus,
  UserMinus,
  Download,
  LogIn,
  LogOut,
  CreditCard,
  Search,
  Database,
  FileText,
  Shield,
  Bell
} from "lucide-react";
import React from "react";

export const SwalFunction = async () => {
  const result = await Swal.fire({
    title: "Unlock Email?",
    text: "1 credit will be used to unlock this email.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Unlock",
    cancelButtonText: "No",
    reverseButtons: true,
    backdrop: true,
  });

  return result
}
// region common function to capitalize the word
export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
// endregion


export const getInitials = (name = "") => {
  if (!name.trim()) return "";

  const words = name.trim().split(/\s+/);

  if (words.length >= 2) {
    return (
      words[0][0] + words[1][0]
    ).toUpperCase();
  }

  return words[0].substring(0, 2).toUpperCase();
};


export const getActivityIcon = (activityType) => {
  switch (activityType) {
    case "USER_REGISTERED":
      return {
        icon: <UserPlus size={14} />,
        className: "green"
      };

    case "ACCOUNT_DELETED":
      return {
        icon: <UserMinus size={14} />,
        className: "red"
      };

    case "CONTACT_DOWNLOADED":
      return {
        icon: <Download size={14} />,
        className: "blue"
      };

    case "USER_LOGIN":
      return {
        icon: <LogIn size={14} />,
        className: "primary"
      };

    case "USER_LOGOUT":
      return {
        icon: <LogOut size={14} />,
        className: "gray"
      };

    case "SUBSCRIPTION_PURCHASED":
      return {
        icon: <CreditCard size={14} />,
        className: "purple"
      };

    case "SAVED_SEARCH_CRITERIA":
      return {
        icon: <Search size={14} />,
        className: "cyan"
      };

    case "LIST_CREATED":
      return {
        icon: <Database size={14} />,
        className: "orange"
      };
    case "DATA_IMPORTED":
      return {
        icon: <Database size={14} />,
        className: "orange"
      };

    case "USER_ADDED":
      return {
        icon: <FileText size={14} />,
        className: "indigo"
      };

    case "ROLE_CHANGED":
      return {
        icon: <Shield size={14} />,
        className: "yellow"
      };

    default:
      return {
        icon: <Bell size={14} />,
        className: "blue"
      };
  }
};


// #region date picket fucntion to add calender icon in react date picker
export const CustomDateInput = React.forwardRef(
  ({ value, onClick, onClear, placeholderText }, ref) => (
    <div className="date-picker-wrapper">
      <input
        ref={ref}
        type="text"
        value={value || ""}
        onClick={onClick}
        readOnly
        placeholder={placeholderText}
        className="form-control"
      />

      {/* {value && (
        <FaTimes
          className="clear-icon"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClear();
          }}
        />
      )} */}

      <FaCalendarAlt
        className="calendar-icon"
        onClick={onClick}
      />
    </div>
  )
);

CustomDateInput.displayName = "CustomDateInput";
// #endregion